export default __webpack_public_path__ + "static/media/farmers2.2279703a.jpg";